import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { Btn } from '../../../../AbstractElements';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { Icon } from '@progress/kendo-react-common';
import { faCertificate } from '@fortawesome/pro-duotone-svg-icons';
import { useSelector } from 'react-redux';
import { useAuth } from 'oidc-react';
import TelerikDataTable from '../../../../CommonComponents/TelerikDataTable';
import visileColumns from "./visibleColumns";
import AdvanceSearch from '../../../../CommonComponents/AdvanceSearch';
import DisplayDataComponent from './DisplayDataComponent';


export const AuditTrailByApplicant = ({ detailData: detailDataProp, embedded = false } = {}) => {
  const navigate = useNavigate()
  const location = useLocation();
  const { detailData: detailDataFromState } = location?.state || {};
  const detailData = detailDataProp ?? detailDataFromState;
  const {GENERAL_AVAILIBILITY_ID,ANNOUNCEMENT_ID,ELIGIBILITY_ID,APPLICANT_SSN,APPLICATION_ID} = JSON.parse(detailData)
  const id = "Audit-trail-report";
    const { columns, loadingSearch, ColumnsSorted, searchParameter, searchResultsV2 } = useSelector((state) => state.advanceSearchv2Reducer);
    const { results, rowCount } = useMemo(() => {
        const searchResult = searchResultsV2[id] || { results: [], rowCount: 0 };
        return {
          results: searchResult.results,
          rowCount: searchResult.rowCount,
        };
      }, [searchResultsV2, id]);
    console.log(results,rowCount,'jobData1221')
    const { userData } = useAuth();
    const [expandedSearchResult, setexpandedSearchResult] = useState(false);
    const { filter: storeFilter, pageSize: storePageSize } = useSelector((state) => state.CommonReducer);
    const [page, setPage] = useState(1);
    const [additionalWhere, setAdditionalWhere] = useState("");
    const { sort } = useSelector((state) => state?.CommonReducer) || {};
    const [sortData, setSortData] = useState([
        { field: "ANNOUNCEMENT_ID", dir: "desc" },
    ]);
    const [searchParams, setSearchParams] = useState([
      {
        columnName: "GENERAL_AVAILIBILITY_ID",
        value: GENERAL_AVAILIBILITY_ID?.trim(),
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
      {
        columnName: "ANNOUNCEMENT_ID",
        value: ANNOUNCEMENT_ID?.trim(),
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
      {
        columnName: "ELIGIBILITY_ID",
        value: ELIGIBILITY_ID?.trim(),
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
      {
        columnName: "APPLICANT_SSN",
        value: APPLICANT_SSN?.trim(),
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
      {
        columnName: "APPLICATION_ID",
        value: APPLICATION_ID?.trim(),
        operator: "=",
        dataType: "varchar(MAX)",
        logicOperator: "AND",
      },
    ]);
    const [pageSize, setPageSize] = useState(storePageSize[id] || 100);
    const [deleteData, setDeleteData] = useState(null);
    const [gg1ExportParams, setGG1ExportParams] = useState({});
    const [selectedRow, setSelectedRow] = useState(null);
    const [chooseFilterMethod, setChooseFilterMethod] = useState("normalSearch");
    const [inlineDetailItem, setInlineDetailItem] = useState(null);

    const { postingResult, loading } = useSelector(
        (state) => state.JobAnnouncementReducer
    );


    const actions = useMemo(() => {
        return [
            {
                title: "View",
                icon: { iconName: "k-icon k-i-eye" },
                className: "font-primary",
                style: { cursor: "pointer" },
                action: (props) => {
                    // console.log("added to table", props.dataItem);
                    // setApplicantTableShow(false)
                    // setEligibilityTableShow(props.dataItem);
                    // setCurrentStep(1)
                    if (embedded) {
                        setInlineDetailItem(props?.dataItem);
                        return;
                    }
                    navigate('detail', { state: { detailData: JSON.stringify(props?.dataItem) } });
                },
                isVisible: (dataProps) => {
                    return (
                      true
                        // dataProps?.ANNOUNCEMENT_ID?.trim() != ANNOUNCEMENT_ID_Value
                    );
                  },
            },
            // {
            //     title: "Select",
            //     icon: { iconName: "k-icon k-i-radiobutton-checked" },
            //     className: "font-primary",
            //     style: { cursor: "pointer" },
            //     action: (props) => {
            //         // setEligibilityTableShow(props.dataItem);
            //     },
            //     isVisible: (dataProps) => {
            //         console.log("dataProps1221", dataProps?.ANNOUNCEMENT_ID?.trim(),ANNOUNCEMENT_ID_Value);
            //         return (
            //             dataProps?.ANNOUNCEMENT_ID?.trim() == ANNOUNCEMENT_ID_Value
            //         );
            //       },
            // }
        ];
    }, [embedded]);


    useEffect(() => {
        if (searchParameter[id]?.searchParams?.length > 0) {
            setSearchParams(JSON.parse(searchParameter[id]?.searchParams));
        }
    }, [searchParameter]);

    const [sortedColumns, setSortedColumns] = useState(visileColumns);

    // const [sortedColumns, setSortedColumns] = useSortedColumns(
    //     id,
    //     ColumnsSorted,
    //     [],
    //     visileColumns,
    //     userData
    // );

    const handlePageChange = (event) => {
        setPage(event.page.skip / event.page.take + 1);
        setPageSize(event.page.take);
    };

    const handleSortChange = (sort) => {
        setSortData(sort);
        setPage(1);
        setPageSize(100);
    };

    const handleFilterChange = (data) => {
        setAdditionalWhere(data);
        setPage(1);
        setPageSize(100);
    };

    const handlePageSizeChange = (event) => {
        setPageSize(event.target.value);
        setPage(1);
    };
  return (
    <Container fluid={true}>
      {!embedded && (
        <Row className="bg-primary rounded py-2 mb-3 sticky-top">
          <Col className="d-flex align-items-center gap-2">
            <Btn
              attrBtn={{
                color: "primary",
                onClick: () => {
                  // openCloseSidebar();
                  navigate(-1);
                },
                //   className: "custom-back-button",
                //   title: "Back to Menu",
                style: {
                  fontSize: "18px",
                  outline: "1px solid white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px 8px",
                  paddingRight: "10px",
                  // fontSize: '1rem',
                  cursor: "pointer",
                  marginRight: "6px",
                },
              }}
            >
              <Icon
                size="medium"
                style={{
                  fontSize: "25px",
                  marginRight: "5px",
                  // cursor:"pointer",
                }}
                name="arrow-left"
                onClick={() => {
                  navigate(-1);
                }}
              />
              Back
            </Btn>
            <FontAwesomeIcon icon={faCertificate} size="xl" />
            <Typography
              variant="h6"
              style={{ color: "white", display: "flex", alignItems: "center" }}
            >
              Audit Trail
            </Typography>
          </Col>
        </Row>
      )}
      <Row>
        <Col sm="12" className="page-content">
          <Card>
            {/* <CardHeader>
              <div className="d-flex align-items-center">
                <div className="w-100">
                  <h5 className="m-0">Job Announcements List</h5>
                </div>
              </div>
            </CardHeader> */}
            <CardBody>
              <AdvanceSearch
                id={id}
                gridId={id}
                location="pmis-global"
                columnList={"*"}
                columnRefernces={[]}
                tableName={"GET-CERTIFICATION-N-GA-AUDIT-TRAIL"}
                searchParams={searchParams}
                additionalWhere={additionalWhere}
                expanded={false}
                sortData={sortData}
                pageNumber={page}
                pageSize={pageSize}
                chooseFilterMethod={"normalSearch"}
              />
              <div>
                <TelerikDataTable
                  id={id}
                  pageNumber={page}
                  pageSize={pageSize}
                  totalCount={rowCount}
                  skip={(page - 1) * pageSize}
                  take={pageSize}
                  data={results || []}
                  sortData={sortData}
                  tableName={"GET-CERTIFICATION-N-GA-AUDIT-TRAIL"}
                  searchParams={searchParams}
                  additionalWhere={additionalWhere}
                  onFilterChange={handleFilterChange}
                  onSortChange={handleSortChange}
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  selectedColumns={sortedColumns}
                  setSortedColumns={setSortedColumns}
                  loading={loadingSearch}
                  enableFooterCell={false}
                  dataLocation="pmis-global"
                  actions={actions}
                  setChooseFilterMethod={setChooseFilterMethod}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {embedded && (
        <Modal isOpen={Boolean(inlineDetailItem)} toggle={() => setInlineDetailItem(null)} size="xl">
          <ModalHeader toggle={() => setInlineDetailItem(null)}>Audit Trail Detail</ModalHeader>
          <ModalBody>
            {inlineDetailItem && <DisplayDataComponent data={inlineDetailItem} />}
          </ModalBody>
          <ModalFooter>
            <Btn attrBtn={{ color: "secondary", onClick: () => setInlineDetailItem(null) }}>Close</Btn>
          </ModalFooter>
        </Modal>
      )}
    </Container>
  );
}
